import { render } from "./CheckAddressPage.vue?vue&type=template&id=72554887&scoped=true"
import script from "./CheckAddressPage.vue?vue&type=script&lang=js"
export * from "./CheckAddressPage.vue?vue&type=script&lang=js"

import "./CheckAddressPage.vue?vue&type=style&index=0&id=72554887&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72554887"]])

export default __exports__